<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">课程管理</Breadcrumb-item>
        <Breadcrumb-item>课后习题</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px" @keyup.enter="search">
      <Form :label-width="80" labe-position="left">
        <Row :gutter="32">
          <Col span="5">
          <FormItem label="教材版本：">
            <Select v-model="queryParam.materialVersion" @on-change="medition" placeholder="请选择" clearable>
              <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
            </Select>
          </FormItem>
          </Col>
          <i-col span="5">
            <Form-item label="课程等级：">
              <Select v-model="queryParam.levelItem"  @on-change="changeLevel" clearable>
                <Option v-for="item in levelAll"
                        :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col span="5">
            <Form-item label="课程标题：">
              <Select v-model="queryParam.lessonItem"   clearable>
                <Option v-for="item in lessonAll"
                        :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <Col span="5">
          <Form-item label="课后题标题：" :label-width="100">
            <Input placeholder="支持模糊查询"  v-model="queryParam.title"></Input>
            <input type="text" style="display: none">
          </Form-item>
          </Col>
          <Col span="2">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
          </Col>
        </Row>
      </Form>
      <Col>
      </Col>

    </div>
    <div class="btn-wrap">
      <Button type="primary" icon="plus-round"
                    @click="onAdd">添加课后习题
            </Button>
    </div>
    <List style="margin-top: 10px" :tableColumns="title" listUrl="/bookLessonNewReview/list"
          :params="queryParam" :onLoading="onLoading"  :reload="reload" ></List>

    <Modal title="课后习题" v-model="editModal" :scrollable="true" :styles="{top: '60px', marginBottom: '50px'}" width="1000">
      <Form ref="form" class="form formModal" :model="formDate" :rules="ruleLevelGrade" :label-width="80" style="overflow: visible;height:auto">
        <Row>
          <Row>
            <i-col :span="22">
              <FormItem label="教材版本：" prop="materialVersion" :label-width="110">
                <Select v-model="formDate.materialVersion"  @on-change="meditions" placeholder="请选择" transfer clearable>
                  <Option v-for="item in $constant.materialVersions"
                          :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
              </FormItem>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-item label="选择level：" :label-width="110" prop="levelItem">
                <Select v-model="formDate.levelItem"  @on-change="changeModelLevel" transfer>
                  <Option v-for="item in levelAlls"
                          :value="item.id" :key="item.id">{{ item.title }}</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-item label="选择对应课程：" :label-width="110" prop="lessonItem" transfer>
                <Select v-model="formDate.lessonItem"  transfer>
                  <Option v-for="item in lessonAlls"
                          :value="item.id" :key="item.id">{{ item.title }}</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-item label="序号：" prop="sort" :label-width="110">
                <Input v-model.number="formDate.sort"></Input>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-item label="考核能力：" :label-width="110" transfer>
                <Select v-model="formDate.appraise"  transfer>
                  <Option v-for="item in $constant.appraise"
                          :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-item label="题型：" :label-width="110" transfer>
                <Select v-model="formDate.questionType"  @on-change="changeQuestionType" transfer>
                  <Option v-for="item in $constant.questionType"
                          :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <i-col :span="22">
              <Form-item :label-width="110" transfer>
                <Select v-model="formDate.questionDev" @on-change="changeQuestionDev" transfer>
                  <Option v-for="item in questionDevList"
                          :value="item.id" :key="item.id">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>

          <Row>
            <i-col :span="22">
              <Form-item label="标题：" prop="title" :label-width="110">
                <Input v-model="formDate.title"/>
              </Form-item>
            </i-col>
          </Row>
          <Row>
            <Row>
              <i-col :span="22">
                <Form-item label="主内容：" :label-width="110">
                  <Input v-model="formDate.content"/>
                </Form-item>
              </i-col>
            </Row>
            <Row v-if="formDate.questionType === 3 && formDate.questionDev === 1">
              <Row v-for="index in answerList.length">
                <i-col :span="22">
                  <Form-item :label="SecondlyContext + index" :label-width="110">
                    <Input v-model="manyContext[index]"/>
                  </Form-item>
                </i-col>
              </Row>
            </Row>
          </Row>
         <!-- <Row>
            <i-col :span="22">
              <Form-item label="状态：" prop="status" :label-width="110">
                <Select v-model="formDate.status">
                  <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>-->

          <Row>
            <span style="display: block;padding-left: 45px;color: #e60000" v-if="formDate.questionType === 1 || (formDate.questionType === 2 && formDate.questionDev === 2)">图片尺寸：894 X 370 (请按照规范上传)</span>
            <span style="display: block;padding-left: 45px;color: #e60000" v-if="formDate.questionType === 2 && formDate.questionDev === 1">图片尺寸：475 X 472 (请按照规范上传)</span>
            <span style="display: block;padding-left: 45px;color: #e60000" v-if="formDate.questionType === 2 && formDate.questionDev === 3">图片尺寸：372 X 213 (请按照规范上传)</span>
            <span style="display: block;padding-left: 45px;color: #e60000" v-if="formDate.questionType === 3 && formDate.questionDev === 1">图片尺寸：542 X 309 (请按照规范上传)</span>
            <span style="display: block;padding-left: 45px;color: #e60000" v-if="formDate.questionType === 3 && formDate.questionDev === 2">图片尺寸：917 X 288 (请按照规范上传)</span>
              <i-col :span="22">
              <Row :gutter="6">
                  <i-col :span="9">
                  <Form-item label="图片" >
                    <image-upload :defaultFileList="defaultPicList"
                                  v-model="formDate.pic" text="上传图片"></image-upload>
                  </Form-item>
                  </i-col>
                  <Form-item label="音频">
                      <i-col :span="6">
                        <file-upload :defaultFileList="defaultAudioList"
                                     text="上传音频" accept="audio/*" v-model="formDate.video"></file-upload>
                      </i-col>
                  </Form-item>
                </Row>
                <span style="display: block;padding-left: 45px;color: #e60000" v-if="formDate.questionType === 3 && formDate.questionDev === 2">车过桥类型：答案图片上传时不管是3张图片或4张图片宽度总和要为361,高度每张为179</span>
            </i-col>
          </Row>

          <Row v-if="formDate.questionType === 2 && formDate.questionDev === 3">
            <Row>
              <span style="display: block;padding-left: 45px;color: #e60000">图片尺寸：185 X 215 (请按照规范上传)</span>
              <i-col :span="12">
                <Form-item label="拼图" >
                  <image-upload :defaultFileList="pinPicList"
                                v-model="formDate.pinPic" text="上传图片"></image-upload>
                </Form-item>
              </i-col>
            </Row>
          </Row>

          <Row v-if="formDate.questionType === 1">
            <Row>
              <i-col :span="22">
                <Form-item label="答案：" :label-width="110">
                  <Input v-model="answerMore[0]"/>
                </Form-item>
              </i-col>
            </Row>
          </Row>
        </i-col>
        <i-col :span="11" :offset="1">
          <Row v-if="formDate.questionType === 2 && formDate.questionDev === 1">
            <template v-for="(item, index) in formDate.levelQuestionSelectOneList">
            <Row>
              <i-col :span="22">
                <Form-item :label="text + (index + 1)" :label-width="110">
                  <Input v-model="item.info"/>
                </Form-item>
              </i-col>
            </Row>
            <Row :gutter="6">
              <span style="display: block;padding-left: 45px;color: #e60000">图片尺寸：271 X 178 (请按照规范上传)</span>
              <i-col :span="9">
                <Form-item label="图片" >
                  <image-upload :defaultFileList="selectDefaultImages[index]"
                                v-model="item.pic" text="上传图片"></image-upload>
                </Form-item>
              </i-col>
              <Form-item label="音频">
                <i-col :span="6">
                  <file-upload :defaultFileList="selectDefaultVideo[index]"
                               text="上传音频" accept="audio/*" v-model="item.video"></file-upload>
                </i-col>
              </Form-item>
            </Row>
            </template>
            <Row>
              <i-col :span="22">
                <Form-item label="答案：" :label-width="110" transfer>
                  <Select v-model="answerMore[0]" transfer>
                    <Option v-for="item in $constant.questionAnswer"
                            :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </i-col>
            </Row>
          </Row>

          <Row v-if="formDate.questionType === 2 && formDate.questionDev === 2">
            <template v-for="(item, index) in formDate.levelQuestionSelectOneList">
              <Row>
                <i-col :span="22">
                  <Form-item :label="text + (index + 1)" :label-width="110">
                    <Input v-model="item.info"/>
                  </Form-item>
                </i-col>
              </Row>
              <Row :gutter="6">
                <Form-item label="音频">
                  <i-col :span="6">
                    <file-upload :defaultFileList="selectDefaultVideo[index]"
                                 text="上传音频" accept="audio/*" v-model="item.video"></file-upload>
                  </i-col>
                </Form-item>
              </Row>
            </template>
            <Row>
              <i-col :span="22">
                <Form-item label="答案：" :label-width="110" transfer>
                  <Select v-model="answerMore[0]" transfer>
                    <Option v-for="item in $constant.questionAnswer"
                            :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </i-col>
            </Row>
          </Row>




       <!-- <Row>
          <i-col :span="22">
            <Form-item label="答案" prop="answer">
              <Row>
                <Radio-group v-model="formDate.answer">
                  <template v-for="(item, index) in formDate.levelQuestionSelectDtoList">
                    <Row>
                      <Radio :label="index + 1"><Input v-model="item.info"/></Radio>
                      <image-upload :defaultFileList="selectDefaultImages[index]" v-model="item.pic"
                                    class="answer-image"></image-upload>
                    </Row>
                  </template>
                </Radio-group>
              </Row>
            </Form-item>
          </i-col>
        </Row>-->

          <Row v-if="formDate.questionType === 2 && formDate.questionDev === 3">
            <template v-for="(item, index) in formDate.levelQuestionSelectOneList">
              <span>选项{{index+1}}</span>
              <Row :gutter="6">
                <span style="display: block;padding-left: 45px;color: #e60000">图片尺寸 235 X 216 (请按照规范上传)</span>
                <i-col :span="9">
                  <Form-item label="图片" >
                    <image-upload :defaultFileList="selectDefaultImages[index]"
                                  v-model="item.pic" text="上传图片"></image-upload>
                  </Form-item>
                </i-col>
                <Form-item label="音频">
                  <i-col :span="6">
                    <file-upload :defaultFileList="selectDefaultVideo[index]"
                                 text="上传音频" accept="audio/*" v-model="item.video"></file-upload>
                  </i-col>
                </Form-item>
              </Row>
            </template>
            <Row>
              <i-col :span="22">
                <Form-item label="答案：" :label-width="110" transfer>
                  <Select v-model="answerMore[0]" transfer>
                    <Option v-for="item in $constant.questionAnswer"
                            :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </i-col>
            </Row>
          </Row>


          <Row v-if="formDate.questionType === 3 && formDate.questionDev === 1">
            <template v-for="(item, index) in formDate.levelQuestionSelectOneList">
              <Row :gutter="6">
                <i-col :span="22">
                  <Form-item :label="text + (index + 1)" :label-width="110">
                    <Input v-model="item.info"/>
                  </Form-item>
                </i-col>
                <Form-item label="音频">
                  <i-col :span="6">
                    <file-upload :defaultFileList="selectDefaultVideo[index]"
                                 text="上传音频" accept="audio/*" v-model="item.video"></file-upload>
                  </i-col>
                </Form-item>
              </Row>
            </template>
            <template v-for="(item, index) in answerList">
              <Row>
                <i-col :span="22">
                  <Form-item :label="answerText + (index + 1)" :label-width="110" transfer>
                    <Select v-model="answerMore[index]" transfer>
                      <Option v-for="item in $constant.questionAnswer"
                              :value="item.code" :key="item.code">{{ item.text }}</Option>
                    </Select>
                  </Form-item>
                </i-col>
              </Row>
            </template>
          </Row>

          <Row v-if="formDate.questionType === 3 && formDate.questionDev === 2">
            <template v-for="(item, index) in formDate.levelQuestionSelectOneList">
              <span>选项{{index+1}}</span>
              <Row :gutter="6">
                <i-col :span="9">
                  <Form-item label="图片" >
                    <image-upload :defaultFileList="selectDefaultImages[index]"
                                  v-model="item.pic" text="上传图片"></image-upload>
                  </Form-item>
                </i-col>
                <Form-item label="音频">
                  <i-col :span="6">
                    <file-upload :defaultFileList="selectDefaultVideo[index]"
                                 text="上传音频" accept="audio/*" v-model="item.video"></file-upload>
                  </i-col>
                </Form-item>
              </Row>
            </template>
            <template v-for="(item, index) in answerList">
              <Row>
                <i-col :span="22">
                  <Form-item :label="answerText + (index + 1)" :label-width="110" transfer>
                    <Select v-model="answerMore[index]" transfer>
                      <Option v-for="item in $constant.questionAnswer"
                              :value="item.code" :key="item.code">{{ item.text }}</Option>
                    </Select>
                  </Form-item>
                </i-col>
              </Row>
            </template>
          </Row>
        </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editModal=false">取消</Button>
        <Button type="primary" size="large"  @click="insert">保存</Button>
      </div>
    </Modal>

  </div>
</template>
<script>

  export default {
    components: {
    },
    data () {
      let $constant = this.$constant
      return {
        statusList: $constant.enabledStatus,
        classReviewId: null,
        isDisabled: false,
        reload: 0,
        text: '选项',
        answerText: '答案',
        SecondlyContext: '次内容',
        searchLoading: false,
        editModal: false,
        questionDevList: [{id: 1, text: '题型1'}, {id: 2, text: '题型2'}],
        answerMore: {},
        levelAll: [],
        levelAlls: [],
        lessonAll: [],
        lessonAlls: [],
        levelGrades: [],
        defaultPicList: [],
        pinPicList: [],
        defaultAudioList: [],
        selectDefaultImages: [],
        selectDefaultVideo: [],
        answerOneList: [
          {
            id: '1',
            info: '',
            answer: ''
          }
        ],
        answerList: [
          {
            id: '1',
            info: '',
            answer: ''
          },
          {
            id: '2',
            info: '',
            answer: ''
          },
          {
            id: '3',
            info: '',
            answer: ''
          },
          {
            id: '4',
            info: '',
            answer: ''
          },
        ],
        manyContext: {},
        queryParam: {
          materialVersion: '',
          title: '',
          levelItem: '',
          lessonItem: '',
        },
        formDate: {
          id: '',
          pinPic: '',
          appraise: '',
          questionType: 1,
          questionDev: 1,
          content: '',
          video: '',
          levelQuestionSelectOneList: [
            {
              id: '1',
              info: '',
              pic: '',
              video: ''
            },
            {
              id: '2',
              info: '',
              pic: '',
              video: ''
            },
            {
              id: '3',
              info: '',
              pic: '',
              video: ''
            },
            {
              id: '4',
              info: '',
              pic: '',
              video: ''
            },
          ],
          materialVersion: '',
          title: '',
          levelItem: '',
          lessonItem: '',
          name: '',
          voice: '',
          pic: '',
          answer: '',
          sort: '',
          status: 1,
          levelQuestionSelectDtoList: [
            {
              id: '1',
              info: '',
              pic: ''
            },
            {
              id: '2',
              info: '',
              pic: ''
            },
            {
              id: '3',
              info: '',
              pic: ''
            },
          ],
        },
        ruleLevelGrade: {
          title: [
            {type: 'string', required: true, message: '标题不能为空', trigger: 'blur'}
          ],
          lessonItem: [
            {type: 'integer', required: true, message: '课程不能为空', trigger: 'blur'}
          ],
          sort: [
            {type: 'integer', required: true, message: '排序不能为空', trigger: 'blur'}
          ],
          name: [
            {type: 'string', required: true, message: '题目不能为空', trigger: 'blur'}
          ],
          status: [
            {type: 'integer', required: true, message: '状态不能为空', trigger: 'blur'}
          ]
        },
        title: [
          {
            title: 'ID',
            // width: 70,
            align: 'center',
            key: 'id'
          },
          {
            title: '序号',
            // width: 70,
            align: 'center',
            key: 'sort'
          },
          {
            title: '课后题标题',
            // width: 120,
            align: 'center',
            key: 'title'
          },
          {
            title: '考核内容',
            // width: 90,
            align: 'center',
            key: 'appraise',
            render: (h, params) => {
              let ap = params.row.appraise
              return h('span', $constant.getEnum($constant.lessonReviewAppraise, ap).text)
            }
          },
          {
            title: '题型',
            // width: 120,
            align: 'center',
            key: 'questionType',
            render: (h, params) => {
              let qt = params.row.questionType
              let qd = params.row.questionDev
              return h('span', $constant.getEnum($constant.lessonReviewQuestionType, qt).text + '-题型' + qd)
            }
          },
          {
            title: '教材版本',
            // width: 100,
            align: 'center',
            key: 'materialVersion',
            render: (h, params) => {
              let status = params.row.materialVersion
              if (status === 1) {
                return h('span', '教材1.0')
              } else if (status === 2) {
                return h('span', '教材2.0')
              } else if (status === 3) {
                return h('span', '教材3.0')
              } else if (status === 4) {
                return h('span', '教材4.0')
              } else {
                return h('span', '其他')
              }
            }
          },
          {
            title: '课程等级',
            // width: 120,
            align: 'center',
            key: 'titleLevel'
          },
          {
            title: '课程标题',
            // width: 120,
            align: 'center',
            key: 'lessonTitle'
          },
          {
            title: '状态',
            // width: 70,
            align: 'center',
            key: 'status',
            render: (h, params) => {
              let status = params.row.status
              if (status === 0) {
                return h('span', '未启用')
              } else if (status === 1) {
                return h('span', '启用')
              } else if (status === -1) {
                return h('span', '禁用')
              } else {
                return h('span', '未知')
              }
            }
          },
          {
            title: '创建时间',
            // width: 170,
            align: 'center',
            key: 'gmtCreate'
          },
          {
            title: '更新时间',
            // width: 170,
            align: 'center',
            key: 'gmtModified'
          },
          {
            title: '操作',
            // width: 120,
            align: 'center',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.onEdit(params.row)
                    }
                  }
                }, '编辑'),
                h('span', {class: 'divider'}, ' | '),
                h('a', {
                  on: {
                    click: () => {
                      this.showStudentQuestion(params.row)
                    }
                  }
                }, '预览')
              ])
            }
          },
        ]
      }
    },
    methods: {
      changeQuestionType (val) {
        let self = this
        if (val === 1) {
          self.questionDevList = [{id: 1, text: '题型1'}, {id: 2, text: '题型2'}]
        } else if (val === 2) {
          self.questionDevList = [{id: 1, text: '题型1'}, {id: 2, text: '题型2'}, {id: 3, text: '题型3'}]
        } else if (val === 3) {
          self.questionDevList = [{id: 1, text: '题型1'}, {id: 2, text: '题型2'}]
        }

        if (!self.classReviewId) {
          this.answerList = [
            {
              id: '1',
              info: '',
              answer: ''
            },
            {
              id: '2',
              info: '',
              answer: ''
            },
            {
              id: '3',
              info: '',
              answer: ''
            },
            {
              id: '4',
              info: '',
              answer: ''
            },
          ]

          this.answerOneList = [
            {
              id: '1',
              info: '',
              answer: ''
            }
          ]
          this.defaultPicList = []
          this.defaultAudioList = []
          this.selectDefaultImages = []
          this.selectDefaultVideo = []
        }
      },
      changeQuestionDev (val) {
        if (!this.classReviewId) {
          this.answerList = [
            {
              id: '1',
              info: '',
              answer: ''
            },
            {
              id: '2',
              info: '',
              answer: ''
            },
            {
              id: '3',
              info: '',
              answer: ''
            },
            {
              id: '4',
              info: '',
              answer: ''
            },
          ]
          this.answerOneList = [
            {
              id: '1',
              info: '',
              answer: ''
            }
          ]
          this.defaultPicList = []
          this.defaultAudioList = []
          this.selectDefaultImages = []
          this.selectDefaultVideo = []
        }
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      search () {
        this.reload = new Date().getTime()
      },
      changeLevel (val) {
        let self = this
        if (val) {
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res && res.data) {
              self.lessonAll = res.data
            }
          })
        }
      },
      changeModelLevel (val) {
        let self = this
        if (val) {
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res && res.data) {
              self.lessonAlls = res.data
            }
          })
        }
      },
      medition (val) {
        let self = this
        if (val) {
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res && res.data) {
              self.levelAll = res.data
            }
          })
        }
      },
      meditions (val) {
        let self = this
        if (val) {
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res && res.data) {
              self.levelAlls = res.data
            }
          })
        }
      },
      onAdd () {
        this.classReviewId = null
        this.isDisabled = false
        this.$helper.reset(this.formDate)
        this.formDate.questionType = 1
        // 处理选题题型
        if (!this.formDate.levelQuestionSelectOneList) {
          this.formDate.levelQuestionSelectOneList = [
            {
              id: '1',
              info: '',
              pic: '',
              video: ''
            },
            {
              id: '2',
              info: '',
              pic: '',
              video: ''
            },
            {
              id: '3',
              info: '',
              pic: '',
              video: ''
            },
            {
              id: '4',
              info: '',
              pic: '',
              video: ''
            },
          ]
        }
        // 处理单个答案
        if (!this.answerOneList) {
          this.answerOneList = [
            {
              id: '1',
              info: '',
              answer: ''
            }
          ]
        }
        // 处理多个答案
        if (!this.answerList) {
          this.answerList = [
            {
              id: '1',
              info: '',
              answer: ''
            },
            {
              id: '2',
              info: '',
              answer: ''
            },
            {
              id: '3',
              info: '',
              answer: ''
            },
            {
              id: '4',
              info: '',
              answer: ''
            },
          ]
        }
        this.defaultPicList = []
        this.defaultAudioList = []
        this.selectDefaultImages = []
        this.selectDefaultVideo = []
        this.answerMore = {}
        this.manyContext = {}
        this.editModal = true
      },
      onDelete (row) {
        let self = this
        if (row.id) {
          self.$http.post('/bookLessonNewReview/delete', {classReviewId: row.id}).then(function (res) {
            console.log(row.id)
            if (res && res.data > 0) {
              self.$Message.success('删除成功!')
              self.search()
            }
          })
        }
      },
      onEdit (row) {
        let self = this
        if (row.id) {
          self.classReviewId = row.id
          this.isDisabled = true
          this.$http.get('/bookLessonNewReview/queryClassReviewById?classReviewId=' + row.id).then(function (res) {
            if (res && res.data) {
              row = res.data
              self.$helper.copyProperties(row, self.formDate)
              if (row.materialVersion) {
                self.formDate.materialVersion = row.materialVersion
              }
              if (row.levelId) {
                self.formDate.levelItem = row.levelId
              }
              if (row.levelId) {
                self.formDate.lessonItem = row.lessonId
              }
              // 处理默认图片
              self.defaultPicList = row.pic ? [{name: row.pic + '', url: row.picUrl}] : []
              self.defaultAudioList = row.video ? [{name: row.video, url: row.videoUrl}] : []
              self.pinPicList = row.pinPic ? [{name: row.pinPic, url: row.pinPicUrl}] : []

              if (self.formDate.levelQuestionSelectOneList && self.formDate.levelQuestionSelectOneList.length > 0) {
                for (let i in self.formDate.levelQuestionSelectOneList) {
                  let item = self.formDate.levelQuestionSelectOneList[i]
                  self.selectDefaultImages[i] = item.pic ? [{name: item.pic + '', url: item.picUrl}] : []
                  self.selectDefaultVideo[i] = item.video ? [{name: item.video + '', url: item.videoUrl}] : []
                }
              }

              // 处理单个答案
              if (row.answer) {
                self.answerMore = JSON.parse(row.answer)
              }


              if (row.content) {
                self.formDate.content = row.content
              }
              if (row.questionType === 3 && row.questionDev === 1) {
                self.manyContext = JSON.parse(row.content)
                self.formDate.content = self.manyContext[0]
              }
            }
          })
        }
        this.editModal = true
      },
      insert () {
        let self = this
        self.$refs.form.validate((valid) => {
          if (valid) {
            if (self.formDate.levelQuestionSelectOneList) {
              for (let i in self.formDate.levelQuestionSelectOneList) {
                let item = self.formDate.levelQuestionSelectOneList[i]
                let s = {
                  id: item.id,
                  info: item.info,
                  pic: item.pic,
                  video: item.video
                }
                self.formDate.levelQuestionSelectOneList[i] = s
              }
              self.formDate.select = JSON.stringify(self.formDate.levelQuestionSelectOneList)
            }
            if (self.formDate.questionType === 3) {
              self.formDate.answer = JSON.stringify(self.answerMore)
              if (self.formDate.questionDev === 1) {
                self.manyContext[0] = self.formDate.content
                self.formDate.content = JSON.stringify(self.manyContext)
              }
            } else {
              self.formDate.answer = JSON.stringify(self.answerMore)
            }
            self.formDate.lessonId = self.formDate.lessonItem
            self.$http.post('/bookLessonNewReview/insert', self.formDate).then((res) => {
              if (res && res.data > 0) {
                self.search()
                self.$Message.success('提交成功!')
                self.editModal = false
                self.$helper.reset(self.formDate)
              }
            })
          } else {
            self.$Message.warning('表单验证失败!')
          }
        })
      },
      showStudentQuestion (row) {
        let lessonId = row.lessonId
        let self = this
        this.$http.get('/adminUser/getAdminToken?type=student').then(res => {
          if (res.data) {
            if (self.$appConfig.active === 'prod') {
              window.open('http://hellokid.speakstreet.cn/newReview/test?lessonId=' + lessonId + '&token=' + res.data)
            } else {
              window.open('http://test-student.kouyujie.cn/newReview/test?lessonId=' + lessonId + '&token=' + res.data)
            }
          }
        })
        return
      },
    },
  }
</script>


<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// ClassReview.vue?44243cd2